import { render } from "./HelpPanel.vue?vue&type=template&id=670697f2"
import script from "./HelpPanel.vue?vue&type=script&lang=js"
export * from "./HelpPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__